export default __webpack_public_path__ + "static/media/shoes.9c6065e1.jpg";